import React from 'react'
import { getSuffix } from 'client/common/url'
import { Cross, SearchIcon } from 'chemistry'
import { dictionary } from 'client/common/accessability'

const SearchInput = ({
  lang,
  format,
  value,
  placeholder,
  focused,
  inputRef,
  formRef,
  pageModeRef,
  onChange,
  onFocus,
  onBlur,
  onClear,
  onClickSearchIcon,
  t
}) => {
  const onClearHandler = e => {
    e.preventDefault()
    onClear?.()
  }

  const onFocusHandler = e => {
    onFocus(e)
  }

  const actionLink = `${getSuffix(lang, format)}/search`
  return (
    <form ref={formRef} className='sfe-search-form' method='get' action={actionLink} autoComplete='off'>
      <div className='sfe-container'>
        <fieldset>
          <input
            id='searchInput'
            ref={inputRef}
            type='text'
            value={value}
            onChange={onChange}
            onFocus={onFocusHandler}
            onBlur={onBlur}
            className='sfe-search-input'
            placeholder={placeholder}
            name='text'
            autoComplete='off'
          />
          {focused && (
            <button
              onMouseDown={onClearHandler}
              className='search-close'
              data-content={t('searchInput.cancel')}
              tabIndex={-1}
            >
              <Cross color='ui-02-darkest' viewBox='0 0 24 24' width='24px' height='24px' />
            </button>
          )}
          <button
            onClick={e => onClickSearchIcon(e)}
            className='search-magnifier'
            aria-label={`${dictionary(lang).search}`}
          >
            <SearchIcon color='white' width='24px' height='24px' />
          </button>
          {/* input sets page-mode to soft-content search results */}
          <input tabIndex={-1} ref={pageModeRef} id='pageModeInput' style={{ display: 'none' }} name='page-mode' />
        </fieldset>
      </div>
    </form>
  )
}

export default SearchInput
